const modalStyle = (theme) => ({
	root: {
		height: "auto",
	},

	container: {
		display: "block",
	},
	button: {
		width: 200,
		display: "flex",
		margin: "auto",
	},
	textField: {
		width: "auto",
		display: "flex",
		margin: 5,
	},
});

export default modalStyle;
